import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Optional,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { DashboardShellComponent } from '../dashboard-shell/dashboard-shell.component';
import { AuthService } from '@auth0/auth0-angular';
import { MatButtonModule } from '@angular/material/button';
import { SideMenuComponent } from '../side-menu/side-menu.component';

@Component({
  selector: 'thred-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    DashboardShellComponent,
    MatButtonModule,
    SideMenuComponent,
  ],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent {
  constructor(
    private authService: AuthService,
    private router: Router,
    @Inject('LOGO_PATH') public logoPath: string,
    @Optional() @Inject('HOME_PATH') public homePath?: string | undefined,
  ) {}

  goToHome() {
    if (this.homePath) {
      this.router.navigateByUrl(this.homePath);
    }
  }
  logout() {
    this.authService.logout({
      logoutParams: { returnTo: window.location.origin },
    });
  }
}
